import { IPlanPickerResponse, ILiliPlan } from './types';
import { LiliPlanType } from './constants';

export const getAvailablePlans = (currentPlan: string, planPickerData: IPlanPickerResponse) => {
  let availablePlans: ILiliPlan[] = [];
  const pro = planPickerData.plans.filter((plan) => plan.type === LiliPlanType.PRO || plan.type === LiliPlanType.PRO_V2)[0] as ILiliPlan;
  const smart = planPickerData.plans.filter((plan) => plan.type === LiliPlanType.SMART)[0] as ILiliPlan;
  const premium = planPickerData.plans.filter((plan) => plan.type === LiliPlanType.PREMIUM)[0] as ILiliPlan;
  switch (currentPlan) {
    case LiliPlanType.BASIC: {
      availablePlans = [pro, smart, premium];
      break;
    }
    case LiliPlanType.BASIC_V2: {
      availablePlans = [pro, smart, premium];
      break;
    }
    case LiliPlanType.PRO: {
      availablePlans = [smart, premium];
      break;
    }
    case LiliPlanType.PRO_V2: {
      availablePlans = [smart, premium];
      break;
    }
    case LiliPlanType.SMART: {
      availablePlans = [premium];
      break;
    }
    default: { break; }
  }
  return availablePlans;
};
export const getInitialPlan = (
  customerProfile: string,
  plans: ILiliPlan[],
  initialPlanType?: string,
) => {
  if (initialPlanType) {
    const selectedIndex = plans.findIndex((i: any) => i.type === initialPlanType);
    if (selectedIndex !== -1) {
      return plans[selectedIndex];
    }

    return plans[0];
  }

  return plans[0];
};

export const planReportName = (planType: string) => {
  switch (planType) {
    case LiliPlanType.BASIC.toString(): {
      return 'Basic';
    }
    case LiliPlanType.BASIC_V2.toString(): {
      return 'Basic';
    }
    case LiliPlanType.PRO.toString(): {
      return 'Pro';
    }
    case LiliPlanType.PRO_V2.toString(): {
      return 'Pro';
    }
    case LiliPlanType.SMART.toString(): {
      return 'Smart';
    }
    case LiliPlanType.PREMIUM.toString(): {
      return 'Premium';
    }
    default: {
      return undefined;
    }
  }
};
